import React from 'react';
import './DataTable.css';

/**
 * Reusable DataTable component for displaying tabular data
 * @param {array} columns - Array of {key, label, render} objects
 * @param {array} data - Array of row data objects
 * @param {array} actions - Array of {label, onClick, className} objects
 * @param {boolean} loading - Loading state
 * @param {string} emptyMessage - Message when no data
 */
const DataTable = ({
  columns = [],
  data = [],
  actions = [],
  loading = false,
  emptyMessage = 'No data available',
}) => {
  if (loading) {
    return <div className="data-table-loading">Loading...</div>;
  }

  if (data.length === 0) {
    return <div className="data-table-empty">{emptyMessage}</div>;
  }

  return (
    <div className="data-table-wrapper">
      <table className="data-table">
        <thead>
          <tr>
            {columns.map((col) => (
              <th key={col.key}>{col.label}</th>
            ))}
            {actions.length > 0 && <th>Actions</th>}
          </tr>
        </thead>
        <tbody>
          {data.map((row, idx) => (
            <tr key={row.id || idx}>
              {columns.map((col) => (
                <td key={`${row.id || idx}-${col.key}`}>
                  {col.render ? col.render(row[col.key], row) : row[col.key]}
                </td>
              ))}
              {actions.length > 0 && (
                <td className="actions-cell">
                  {actions.map((action, aIdx) => (
                    <button
                      key={aIdx}
                      onClick={() => action.onClick(row)}
                      className={`action-btn ${action.className || ''}`}
                      title={action.label}
                    >
                      {action.label}
                    </button>
                  ))}
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default DataTable;
